import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'matx-notifications2',
  templateUrl: './matx-notifications2.component.html',
  styleUrls: ['./matx-notifications2.component.scss']
})
export class MatxNotifications2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
